import { fireCmdbErrorAnalytics } from '@atlassian/jira-servicedesk-cmdb-error-handling/src/fireCmdbErrorAnalytics.tsx';
import { fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
import {
	performCmdbGetRequest,
	performCmdbPutRequest,
} from '@atlassian/jira-servicedesk-cmdb-client/src/fetch.tsx';
import { getDataManagerProvisioningStatusUrl } from '@atlassian/jira-servicedesk-cmdb-rest-urls/src/common/constants/data-manager.tsx';
import type { ActionApi, ProvisioningStatusResponse } from '../../common/types.tsx';

type UpdateProvisioningStatusParams = {
	isEnabled: boolean;
};

export const updateProvisioningStatus =
	({ isEnabled }: UpdateProvisioningStatusParams): ActionApi =>
	async ({ setState, getState }, { workspaceId, createAnalyticsEvent }) => {
		const state = getState();

		if (state.dataManager.provisioningUpdateLoading) {
			return;
		}

		setState({
			...state,
			dataManager: {
				...state.dataManager,
				isProvisioned: isEnabled,
				provisioningUpdateLoading: true,
			},
		});

		try {
			const requestBody = {
				enabled: isEnabled,
			};

			await performCmdbPutRequest(getDataManagerProvisioningStatusUrl(workspaceId), {
				body: JSON.stringify(requestBody),
			});

			const result: ProvisioningStatusResponse = await performCmdbGetRequest(
				getDataManagerProvisioningStatusUrl(workspaceId),
			);

			setState({
				...state,
				dataManager: {
					...state.dataManager,
					isProvisioned: result.enabled === 'ON',
					provisioningUpdateLoading: false,
				},
			});
			fireTrackAnalytics(createAnalyticsEvent({}), 'updateProvisioningStatus succeeded');

			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			setState({
				...state,
				dataManager: {
					...state.dataManager,
					provisioningUpdateLoading: false,
					provisioningUpdateError: error,
				},
			});

			fireCmdbErrorAnalytics({
				meta: {
					id: 'updateProvisioningStatus',
					packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
				},
				error,
			});

			throw error;
		}
	};
